module.exports = __webpack_public_path__ + "static/media/bellabyte-redes-sociais-facebook.15a21e21.jpg";